import { render, staticRenderFns } from "./FileIcons.vue?vue&type=template&id=635a2780&scoped=true&"
import script from "./FileIcons.vue?vue&type=script&lang=js&"
export * from "./FileIcons.vue?vue&type=script&lang=js&"
import style0 from "./FileIcons.vue?vue&type=style&index=0&id=635a2780&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635a2780",
  null
  
)

export default component.exports